import Badge from "./Badge";

function SectionHeading({
  badge,
  title,
  description,
  align = "left",
  className = "",
  dark = false
}) {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";

  return (
    <div className={`max-w-3xl ${alignment} ${className}`.trim()}>
      {badge ? <Badge>{badge}</Badge> : null}
      <h2
        className={`mt-4 text-3xl font-semibold leading-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.15] ${
          dark ? "text-white" : "text-brand-navy"
        }`}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-4 text-[15px] leading-relaxed sm:text-base lg:text-lg ${
            dark ? "text-white/78" : "text-brand-charcoal/80"
          }`}
        >
          {description}
        </p>
      ) : null}
      <span
        className={`mt-6 block h-1 w-20 rounded-full bg-gradient-to-r from-brand-gold to-brand-gold-strong ${
          align === "center" ? "mx-auto" : ""
        }`}
      />
    </div>
  );
}

export default SectionHeading;
